// 권한 타입 정의
export type Permission =
  | "MEMBER_MANAGEMENT"
  | "CORP_MANAGEMENT"
  | "CLASSROOM_MANAGEMENT"
  | "BUSINESS_REGISTRATION_FIRST_APPROVE"
  | "BUSINESS_REGISTRATION_SECOND_APPROVE"
  | "POINT_MANAGEMENT"
  | "SERVICE_MANAGEMENT"
  | "SHOP_MANAGEMENT";

export enum PermissionEnum {
  MEMBER_MANAGEMENT = "MEMBER_MANAGEMENT",
  CORP_MANAGEMENT = "CORP_MANAGEMENT",
  CLASSROOM_MANAGEMENT = "CLASSROOM_MANAGEMENT",
  BUSINESS_REGISTRATION_FIRST_APPROVE = "BUSINESS_REGISTRATION_FIRST_APPROVE",
  BUSINESS_REGISTRATION_SECOND_APPROVE = "BUSINESS_REGISTRATION_SECOND_APPROVE",
  POINT_MANAGEMENT = "POINT_MANAGEMENT",
  SERVICE_MANAGEMENT = "SERVICE_MANAGEMENT",
  SHOP_MANAGEMENT = "SHOP_MANAGEMENT",
}

// 문의 유형 enum
export enum InquiryType {
  SIGNUP_LOGIN = "SIGNUP_LOGIN",
  CLASS_USAGE = "CLASS_USAGE",
  ATTENDANCE = "ATTENDANCE",
  SYSTEM_ERROR = "SYSTEM_ERROR",
  FEATURE_SUGGESTION = "FEATURE_SUGGESTION",
  PAYMENT_REFUND = "PAYMENT_REFUND",
  FACIAL_INFO = "FACIAL_INFO",
  ETC = "ETC",
  CHEWING_SHOP = "CHEWING_SHOP",
}

// 문의 유형 라벨 매핑
export const INQUIRY_TYPE_LABEL: Record<InquiryType, string> = {
  [InquiryType.SIGNUP_LOGIN]: "회원가입/로그인",
  [InquiryType.CLASS_USAGE]: "클래스 이용",
  [InquiryType.ATTENDANCE]: "출결 관련",
  [InquiryType.SYSTEM_ERROR]: "시스템 오류 신고",
  [InquiryType.FEATURE_SUGGESTION]: "새로운 기능 제안",
  [InquiryType.PAYMENT_REFUND]: "결제 및 환불",
  [InquiryType.FACIAL_INFO]: "얼굴 정보",
  [InquiryType.ETC]: "기타",
  [InquiryType.CHEWING_SHOP]: "카리아카샵",
};

// 사용자 역할 타입
export type UserRole = "SUPER_ADMIN" | "ADMIN";

// /admins/me 응답 타입
export interface AdminMeResponse {
  id: number;
  email: string;
  role: UserRole;
  permissions: Permission[];
  inquiryTypeScope: InquiryType[]; // 빈 배열 = 전체 허용
  partnerScope: number[];          // 빈 배열 = 전체 허용
}

// PUT /admins/{id}/permissions 요청 타입
export interface UpdateAdminPermissionsRequest {
  permissions: Permission[];
  inquiryTypeScope?: InquiryType[];
  partnerScope?: number[];
}

// 권한 체크 함수
export const hasPermission = (
  userRole: UserRole | null,
  userPermissions: Permission[],
  requiredPermissions?: Permission[]
): boolean => {
  // SUPER_ADMIN은 모든 권한을 가짐
  if (userRole === "SUPER_ADMIN") {
    return true;
  }

  // 권한이 정의되지 않은 경우 접근 허용
  if (!requiredPermissions || requiredPermissions.length === 0) {
    return true;
  }

  // 필요한 권한 중 하나라도 가지고 있으면 접근 허용
  return requiredPermissions.some((permission) =>
    userPermissions.includes(permission)
  );
};

// 권한이 있는지 체크 (사이드바용)
export const hasAnyPermission = (
  userRole: UserRole | null,
  userPermissions: Permission[]
): boolean => {
  return userRole === "SUPER_ADMIN" || userPermissions.length > 0;
};
